const pvAnimationDuration = 300;
const galleryPacks = document.querySelectorAll('.js-pv-pack');
if (galleryPacks.length) {
    var pvData = {
        photosId: [],
        originalPhotos: [],
        originalCropPhotos: [],
        thumbsPhotos: [],
        currentPhotos: [],
        position: null,
        slideIndex: null,
        originalPhotosLength: null,
        isOriginalLoaded: false,
        preloaderTimeout: null,
        locked: false,
        x0: null,
        showThumbs: true,
        thumbLoadedAmount: 0,
        originalSliderTrack: document.querySelector('.js-photo-view .original-slider-track'),
        nextBtn: document.querySelector('.js-photo-view .photoviewer-next'),
        prevBtn: document.querySelector('.js-photo-view .photoviewer-prev'),
        photoviewCurrent: document.querySelector('.js-photo-view-counter .photo-view__current'),
        downloadLink: document.querySelector('.js-photo-view-download-photo-btn'),
        shareWidget: document.querySelector('.js-photo-view-share-widget'),
    };

    let closePhotoviewerBtn = document.querySelector('.js-close-photoviewer');
    closePhotoviewerBtn.addEventListener('click', closePhotoviewer);

    pvData.prevBtn.addEventListener('click', prevOriginalSlide);
    pvData.nextBtn.addEventListener('click', nextOriginalSlide);

    pvData.originalSliderTrack.addEventListener('touchstart', lock);
    pvData.originalSliderTrack.addEventListener('touchmove', drag);
    pvData.originalSliderTrack.addEventListener('touchend', move);

    window.addEventListener('resize', handleResize);

    galleryPacks.forEach(pack => {
        const galleryTogglers = pack.querySelectorAll('.js-show-photoviewer');

        galleryTogglers.forEach((item, index) => {
            item.addEventListener('click', function () {
                showPopupPreloader();
                showPopUp('photoviewer-pop-up');
                initPhotoviewer(item, index);
            });
        });
    });

    initByQueryParam();
}

function closePhotoviewer() {
    hidePopUps();
    showPopupPreloader();
    updateQueryParam('photo', '');

    let thumbsSlider = document.querySelector('.thumbs-slider');
    let originalSlider = document.querySelector('.original-slider-track');

    while (thumbsSlider.firstChild) {
        thumbsSlider.removeChild(thumbsSlider.firstChild);
    }
    while (originalSlider.firstChild) {
        originalSlider.removeChild(originalSlider.firstChild);
    }

    document.querySelector('.thumbs').classList.add('visually-hidden');
    pvData.prevBtn.classList.add('visually-hidden');
    pvData.nextBtn.classList.add('visually-hidden');

    pvData = {
        photosId: [],
        originalPhotos: [],
        originalCropPhotos: [],
        thumbsPhotos: [],
        currentPhotos: [],
        position: null,
        slideIndex: null,
        originalPhotosLength: null,
        isOriginalLoaded: false,
        preloaderTimeout: null,
        locked: false,
        x0: null,
        thumbLoadedAmount: 0,
        originalSliderTrack: document.querySelector('.js-photo-view .original-slider-track'),
        nextBtn: document.querySelector('.js-photo-view .photoviewer-next'),
        prevBtn: document.querySelector('.js-photo-view .photoviewer-prev'),
        photoviewCurrent: document.querySelector('.js-photo-view-counter .photo-view__current'),
        downloadLink: document.querySelector('.js-photo-view-download-photo-btn'),
        shareWidget: document.querySelector('.js-photo-view-share-widget'),
    };
}

function initPhotoviewer(el, elIndex) {
    let gallery = el.closest('.js-pv-pack');
    pvData.showThumbs = gallery.dataset.showThumbs;
    let galleryItems = gallery.querySelectorAll('.js-pv-pack-photo');
    galleryItems.forEach((item, index) => {
        pvData.photosId.push(item.dataset.photoId);
        pvData.originalPhotos.push(item.dataset.pvOriginalSrc);
        pvData.originalCropPhotos.push(item.dataset.pvOriginalCropSrc);
        pvData.thumbsPhotos.push(item.dataset.pvThumbSrc);
    });

    pvData.originalPhotosLength = pvData.originalCropPhotos.length;

    showPopupPreloader();

    let thumbsSlider = document.querySelector('.thumbs-slider');
    thumbsSlider.hidden = pvData.showThumbs !== 'true';

    let photoviewTotal = document.querySelector('.js-photo-view-counter .photo-view__total');
    pvData.photoviewCurrent.innerHTML = elIndex+1;
    photoviewTotal.innerHTML = pvData.originalPhotosLength;

    pvData.slideIndex = elIndex+1;

    toggleDisabledArrow(pvData.slideIndex);

    if (elIndex === 0) {
        pvData.position = 0;
    }
    else {
        pvData.position = 1;
    }

    if (elIndex > 0) {
        pvData.currentPhotos.push(pvData.originalCropPhotos[(elIndex-1)]);
    }
    pvData.currentPhotos.push(pvData.originalCropPhotos[elIndex]);
    if (elIndex !== pvData.originalCropPhotos.length-1) {
        pvData.currentPhotos.push(pvData.originalCropPhotos[(elIndex+1)]);
    }

    pvData.thumbsPhotos.forEach((item, index) => {
        createNewThumb(item, index, elIndex);
    });

    pvData.currentPhotos.forEach((item, index) => {
        createNewOriginalSlide(item, 'append', index===pvData.position);
    });

    setOriginalSlide(pvData.position, true);

    let thumbs = document.querySelectorAll('.thumbs-item-wrap');
    thumbs.forEach((item, index) => {
        item.addEventListener('click', function() {
            indexOriginalSlide(index);
        });
    });

    if (pvData.originalPhotosLength > 1) {
        if (pvData.showThumbs) document.querySelector('.thumbs').classList.remove('visually-hidden');
        pvData.prevBtn.classList.remove('visually-hidden');
        pvData.nextBtn.classList.remove('visually-hidden');
    }
}

function getOriginalSliderWidth() {
    let originalSlider = document.querySelector('.original-slider');

    return originalSlider.offsetWidth;
}

function setOriginalSlide(position, withoutTransition) {
    let offset = position * getOriginalSliderWidth();

    if (!withoutTransition) {
        pvData.originalSliderTrack.style.transition = 'transform ' + pvAnimationDuration + 'ms linear';
        setTimeout(()=> {
            pvData.originalSliderTrack.style.transition = '';
        }, pvAnimationDuration);
    }

    if (position === 0) {
        pvData.originalSliderTrack.style.transform = 'translateX(0px)';
    }
    else {
        pvData.originalSliderTrack.style.transform = 'translateX(-' + offset + 'px)';
    }

    let currentActiveSlide = document.querySelector('.original-slide_active');
    if (currentActiveSlide) currentActiveSlide.classList.remove('original-slide_active');
    let newActiveSlide = document.querySelector('.original-slide:nth-child(' + (position+1) + ')');
    if (newActiveSlide) newActiveSlide.classList.add('original-slide_active');

    setThumbsScroll();
    updateDownloadLink();
    updateShareLinks();
    updateQueryParam('photo', pvData.photosId[pvData.slideIndex-1]);
    updateProgressBar();
}

function setThumbsScroll() {
    if (pvData.showThumbs === 'true') {
        let thumbsSlider = document.querySelector('.thumbs-slider');
        let currentThumb = document.querySelector('.thumbs-item-wrap.current');
        let windowPosition = {
                left: thumbsSlider.getBoundingClientRect().left,
                right: thumbsSlider.getBoundingClientRect().right - thumbsSlider.getBoundingClientRect().left,
            },
            targetPosition = {
                left: currentThumb.getBoundingClientRect().left,
                right: currentThumb.getBoundingClientRect().right + 16,
            };

        if (targetPosition.right < windowPosition.right && targetPosition.left > windowPosition.left) {
        } else {
            if (targetPosition.left < windowPosition.left) {
                thumbsSlider.scrollLeft = currentThumb.offsetLeft - currentThumb.clientWidth;
            }

            if (targetPosition.right > windowPosition.right) {
                let nextThumbWidth = document.querySelectorAll('.thumbs-item-wrap')[pvData.slideIndex + 1]
                    ? document.querySelectorAll('.thumbs-item-wrap')[pvData.slideIndex + 1].clientWidth
                    : 0;

                thumbsSlider.scrollLeft = thumbsSlider.scrollLeft + (targetPosition.right - windowPosition.right) + nextThumbWidth;
            }
        }
    }
}

function prevOriginalSlide() {
    if (pvData.slideIndex !== 1) {
        pvData.photoviewCurrent.innerHTML = pvData.slideIndex-1;

        let currentThumb = document.querySelector('.thumbs-item-wrap.current');
        let newCurrentThumb = currentThumb.previousSibling;
        currentThumb.classList.remove('current');
        newCurrentThumb.classList.add('current');

        pvData.slideIndex = pvData.slideIndex-1;

        toggleDisabledArrow(pvData.slideIndex);

        pvData.position = 1;
        setOriginalSlide(0);
        if (pvData.currentPhotos.length === 3) {
            pvData.currentPhotos.pop();
            pvData.originalSliderTrack.removeChild(pvData.originalSliderTrack.lastElementChild);
            if (pvData.slideIndex !== 1) {
                setTimeout(()=> {
                    pvData.currentPhotos.unshift(pvData.originalCropPhotos[pvData.slideIndex-1]);
                    createNewOriginalSlide(pvData.originalCropPhotos[pvData.slideIndex-2], 'prepend');
                    pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
                }, pvAnimationDuration);
            }
        }
        else if (pvData.currentPhotos.length === 2) {
            setTimeout(() => {
                pvData.currentPhotos.unshift(pvData.originalCropPhotos[pvData.slideIndex-1]);
                createNewOriginalSlide(pvData.originalCropPhotos[pvData.slideIndex-2], 'prepend');
                pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
            }, pvAnimationDuration);
        }
    }
}
function nextOriginalSlide() {
    if (pvData.slideIndex !== pvData.originalPhotosLength) {
        pvData.photoviewCurrent.innerHTML = pvData.slideIndex+1;

        let currentThumb = document.querySelector('.thumbs-item-wrap.current');
        let newCurrentThumb = currentThumb.nextSibling;
        currentThumb.classList.remove('current');
        newCurrentThumb.classList.add('current');

        pvData.slideIndex = pvData.slideIndex+1;
        pvData.position = 1;

        toggleDisabledArrow(pvData.slideIndex);

        if (pvData.currentPhotos.length === 2) {
            setOriginalSlide(1);
            pvData.currentPhotos.push(pvData.originalCropPhotos[pvData.slideIndex]);
            createNewOriginalSlide(pvData.originalCropPhotos[pvData.slideIndex], 'append');
        }
        else if (pvData.currentPhotos.length === 3) {
            setOriginalSlide(2);

            if (pvData.slideIndex !== pvData.originalPhotosLength) {
                pvData.currentPhotos.push(pvData.originalCropPhotos[pvData.slideIndex]);
                createNewOriginalSlide(pvData.originalCropPhotos[pvData.slideIndex], 'append');

                setTimeout(()=> {
                    pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
                    pvData.originalSliderTrack.removeChild(pvData.originalSliderTrack.firstChild);
                    pvData.currentPhotos.shift();
                }, pvAnimationDuration);
            }
            else {
                setTimeout(()=> {
                    pvData.originalSliderTrack.removeChild(pvData.originalSliderTrack.firstChild);
                    pvData.currentPhotos.shift();
                    pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
                }, 300);
            }
        }
    }
}
function indexOriginalSlide(index) {
    showPopupPreloader();

    pvData.photoviewCurrent.innerHTML = index+1;

    let currentThumb = document.querySelector('.thumbs-item-wrap.current');
    let newCurrentThumb = document.querySelector('.thumbs-item-wrap:nth-child(' + (index+1) + ')');
    currentThumb.classList.remove('current');
    newCurrentThumb.classList.add('current');

    toggleDisabledArrow(index+1);

    pvData.position = index === 0 ? 0 : 1;

    if (pvData.currentPhotos.length === 2) {
        if (index === 0) {
            let newPhoto = pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(1) .original-photo');
            newPhoto.addEventListener('load', hidePopupPreloader);
            newPhoto.src = '';
            newPhoto.src = pvData.originalCropPhotos[index];
            pvData.currentPhotos.splice(0, 1, pvData.originalCropPhotos[index]);
            setOriginalSlide(0);
            setTimeout(() => {
                pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(2) .original-photo').src = pvData.originalCropPhotos[index+1];
                pvData.currentPhotos.splice(1, 1, pvData.originalCropPhotos[index+1]);
            }, pvAnimationDuration);
        }
        else if (index === pvData.originalPhotosLength-1) {
            let newPhoto = pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(2) .original-photo');
            newPhoto.addEventListener('load', hidePopupPreloader);
            newPhoto.src = '';
            newPhoto.src = pvData.originalCropPhotos[index];
            pvData.currentPhotos.splice(1, 1, pvData.originalCropPhotos[index]);

            setOriginalSlide(1);

            setTimeout(() => {
                pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(1) .original-photo').src = pvData.originalCropPhotos[index-1];
                pvData.currentPhotos.splice(0, 1, pvData.originalCropPhotos[index-1]);
                pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
            }, pvAnimationDuration);
        }
        else {
            let newPhoto = pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(2) .original-photo');
            newPhoto.addEventListener('load', hidePopupPreloader);
            newPhoto.src = '';
            newPhoto.src = pvData.originalCropPhotos[index];
            pvData.currentPhotos.splice(1, 1, pvData.originalCropPhotos[index]);

            createNewOriginalSlide(pvData.originalCropPhotos[index+1], 'append');
            pvData.currentPhotos.push(pvData.originalCropPhotos[index+1]);
            setOriginalSlide(1);
        }
    }
    else {
        if (index >= pvData.slideIndex) {
            let newPhoto = pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(3) .original-photo');
            newPhoto.addEventListener('load', hidePopupPreloader);
            newPhoto.src = '';
            newPhoto.src = pvData.originalCropPhotos[index];
            pvData.currentPhotos.splice(2, 1, pvData.originalCropPhotos[index]);

            setOriginalSlide(2);
            setTimeout(() => {
                if (index < pvData.originalPhotosLength-1) {
                    createNewOriginalSlide(pvData.originalCropPhotos[index+1], 'append');
                    pvData.currentPhotos.push(pvData.originalCropPhotos[index+1]);
                }
                pvData.originalSliderTrack.removeChild((pvData.originalSliderTrack.firstChild));
                pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(1) .original-photo').src = pvData.originalCropPhotos[index-1];
                pvData.currentPhotos.splice(0, 2, pvData.originalCropPhotos[index-1]);
                pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
            }, pvAnimationDuration);
        }
        else {
            let newPhoto = pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(1) .original-photo');
            newPhoto.addEventListener('load', hidePopupPreloader);
            newPhoto.src = '';
            newPhoto.src = pvData.originalCropPhotos[index];
            pvData.currentPhotos.splice(0, 1, pvData.originalCropPhotos[index]);

            setOriginalSlide(0);

            setTimeout(() => {
                pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(2) .original-photo').src = pvData.originalCropPhotos[index+1];
                pvData.originalSliderTrack.removeChild(pvData.originalSliderTrack.querySelector('.original-photo-wrap:nth-child(3)'));
                pvData.currentPhotos.splice(1, 2, pvData.originalCropPhotos[index+1]);
                if (index !== 0) {
                    createNewOriginalSlide(pvData.originalCropPhotos[index-1], 'prepend');
                    pvData.currentPhotos.splice(0, 0, pvData.originalCropPhotos[index-1]);
                    pvData.originalSliderTrack.style.transform = 'translateX(-' + getOriginalSliderWidth() + 'px)';
                }
            }, pvAnimationDuration);
        }
    }

    pvData.slideIndex = index+1;
}

function createNewOriginalSlide(src, where, isActiveSlide) {
    let newOriginalWrap = document.createElement('div');
    newOriginalWrap.className = 'original-slide original-photo-wrap';

    let newOriginal = document.createElement('img');
    newOriginal.className = 'original-photo';

    if (isActiveSlide) {
        newOriginal.addEventListener('load', function (event) {
            hidePopupPreloader();
        });
    }
    newOriginal.src = src;

    newOriginalWrap.appendChild(newOriginal);
    if (where === 'append') {
        pvData.originalSliderTrack.appendChild(newOriginalWrap);
    }
    else if (where === 'prepend') {
        pvData.originalSliderTrack.insertBefore(newOriginalWrap, pvData.originalSliderTrack.firstChild);
    }

    newOriginal.addEventListener('click', function () {
        nextOriginalSlide();
    });
}

function createNewThumb(src, index, elIndex) {
    let thumbsSlider = document.querySelector('.thumbs-slider');

    let newThumbWrap = document.createElement('div');
    newThumbWrap.className = 'thumbs-item-wrap';
    if (index === elIndex) newThumbWrap.className = 'thumbs-item-wrap current';

    let newThumb = document.createElement('img');
    newThumb.className = 'thumbs-item';
    newThumb.src = src;

    newThumbWrap.appendChild(newThumb);
    thumbsSlider.appendChild(newThumbWrap);
}

function handleResize() {
    setOriginalSlide(pvData.position, true);
}

function initByQueryParam() {
    const searchParams = new URLSearchParams(window.location.search);
    const photoParam = searchParams.get('photo');
    if (photoParam) {
        const img = document.querySelectorAll(`img[data-photo-id="${photoParam}"]`)[0];
        if (img) {
            const imgWrap = img.parentElement;
            const imgPvPack = imgWrap.parentElement;
            const nodes = Array.prototype.slice.call(imgPvPack.children);
            const index = nodes.indexOf(imgWrap);

            showPopupPreloader();
            showPopUp('photoviewer-pop-up');
            initPhotoviewer(imgWrap, index);
        }
        else {
            updateQueryParam('photo', '');
        }
    }
}

function toggleDisabledArrow(index) {
    if (index === 1) {
        pvData.nextBtn.classList.remove('disabled');
        pvData.prevBtn.classList.add('disabled');
    }
    else if (index === pvData.originalPhotosLength) {
        pvData.nextBtn.classList.add('disabled');
        pvData.prevBtn.classList.remove('disabled');
    }
    else {
        pvData.nextBtn.classList.remove('disabled');
        pvData.prevBtn.classList.remove('disabled');
    }
}

function updateDownloadLink() {
    const currentOriginalSrc = pvData.originalPhotos[pvData.slideIndex-1];
    const baseUrl = window.location.origin;
    pvData.downloadLink.setAttribute('href', baseUrl + currentOriginalSrc);
}

function updateShareLinks() {
    const aTags = pvData.shareWidget.querySelectorAll('a');
    aTags.forEach(item => {
        const currentId = pvData.photosId[pvData.slideIndex-1];
        const shareUrl = item.dataset.shareUrl;
        const baseUrl = (window.location.origin + window.location.pathname).slice(0, -1);
        item.setAttribute('href', shareUrl + baseUrl + '?photo=' + currentId);
    });
}

function updateProgressBar() {
    const progressBar = document.querySelector('.js-photo-view-progress-bar');
    const percent = Math.round((pvData.slideIndex / pvData.originalPhotosLength) * 100);
    progressBar.style.width = percent + "%";
}


function move(e) {
    let dx = unifyTouchEvent(e).clientX - pvData.x0,
        mathSign = Math.sign(dx),
        windowWidth = window.innerWidth,
        moveDistance = +(mathSign * dx / windowWidth).toFixed(2);

    if (moveDistance > .1) {
        if (dx < 0) {
            nextOriginalSlide();
        }
        else {
            prevOriginalSlide();
        }
    }
    else {
        setOriginalSlide(pvData.position, true);
    }

    pvData.x0 = null;
}
function unifyTouchEvent(e) {
    return e.changedTouches ? e.changedTouches[0] : e;
}
function lock(e) {
    pvData.x0 = unifyTouchEvent(e).clientX;
}
function drag(e) {
    let dx = unifyTouchEvent(e).clientX - pvData.x0,
        currentOffset = pvData.position * getOriginalSliderWidth(),
        offset = currentOffset - dx;

    pvData.originalSliderTrack.style.transition = 'transform .3s linear';
    pvData.originalSliderTrack.style.transform = 'translateX(-' + offset + 'px)';
}
